import cs from 'clsx';
import { FC } from 'react';

import { SpecificationItem } from './components/SpecificationItem';
import { ISpecificationsProps } from './types';

import * as styles from './styles.css';

export const Specifications: FC<ISpecificationsProps> = props => {
  const { className, items } = props;

  return (
    <div className={cs(styles['root'], className)}>
      {items.map(item => (
        <SpecificationItem {...item} className={styles['item']} key={item.key} />
      ))}
    </div>
  );
};

Specifications.displayName = 'Specifications';
